import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { WeightFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { formatWeight } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries.weight;

export function OrderWeightColumn(
  weightFormat: WeightFormat,
): Column2<FulfillmentGroupData> {
  return {
    key: catalogEntry.key,
    title: catalogEntry.title,
    alignment: ColumnAlignment.LEFT,
    width: catalogEntry.defaultWidth,
    renderNormalCell: ({ row }) => (
      <RedoTableTextCell
        text={formatWeight(
          { unit: WeightUnit.G, value: row.displayWeightGrams ?? 0 },
          weightFormat,
        )}
      />
    ),
    sort: catalogEntry.sortDirection,
  };
}
